const { get } = require('lodash');
const Moment = require('moment');
const MomentRange = require('moment-range');
const moment = MomentRange.extendMoment(Moment);

const format = 'YYYY-MM-DD';
module.exports = function(value) {
  const eventDays = get(value, 'value');

  if (!Array.isArray(eventDays)) {
    return [];
  }
  return eventDays.reduce((days, dayRange) => {
    const range = moment.range(dayRange.start, dayRange.end);

    for (let day of range.by('day')) {
      days.push(day.utc().format(format));
    }

    return days;
  }, []);
};
